import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-referente-dettaglio',
  templateUrl: './referente-dettaglio.component.html',
  styleUrls: ['./referente-dettaglio.component.css']
})
export class ReferenteDettaglioComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  objdettaglio: any;
  public isEdit: number = 0

  constructor(public dialogRef: MatDialogRef<ReferenteDettaglioComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettaglio Referente'
  }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
      idReferenteTipologia: [null],
      ReferenteTipologia: [null],
      Visibile: [null]
    })

    if (this.data.iValore >=-1) { //modifica
      // console.log('ivalore modale', this.data.iValore)
      this.getDettaglio(this.data.iValore)
      this.isEdit = 1;
    }
    if (this.data.iValore == -2) { //nuovo
      this.titolo = this.titolo + ' - Inserimento ';
      this.isEdit = 0;
    }

  }

  getDettaglio(iValore: number) {
    this.srvUtilita.getObj('Utenti/GetUtentiProfiloReferenteTipologiaDettaglio?idReferenteTipologia=' + iValore).subscribe((res: any) => {
      this.objdettaglio = res
      //console.log(res, 'res')
      this.frmInserimento.patchValue(this.objdettaglio)
      this.titolo = this.titolo + ": " + this.objdettaglio.ReferenteTipologia
    })
  }


  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    if (objInserimento.Visibile == true) {
      objInserimento.Visibile = 1
    } else {
      objInserimento.Visibile = 0
    }

    const obj = {
      idReferenteTipologia: this.data.iValore,
      ReferenteTipologia: objInserimento.ReferenteTipologia,
      Visibile: objInserimento.Visibile
    }

    if (this.data.iValore >= -1) {
      obj.idReferenteTipologia = this.data.idReferenteTipologia
    } else { obj.idReferenteTipologia = -2; }


    this.srvUtilita.postObj('Utenti/PostReferente', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

}

